var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import Logger from '@cvent/nucleus-logging';
var LOG = new Logger('eventWidget/AppleMapKit');
var AppleMapKit = /** @class */ (function (_super) {
    __extends(AppleMapKit, _super);
    function AppleMapKit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppleMapKit.prototype.componentDidMount = function () {
        var _this = this;
        var eventLatitude = 0.0;
        var eventLongitude = 0.0;
        var eventLatitudeSpan = 0.0;
        var eventLongitudeSpan = 0.0;
        var geocoder = new window.mapkit.Geocoder({});
        var _a = this.props, address1 = _a.address1, city = _a.city, countryCode = _a.countryCode, stateCode = _a.stateCode;
        var eventLocation = address1 + ', ' + city + ', ' + stateCode + ' ' + countryCode;
        geocoder.lookup(eventLocation, function (err, data) {
            var _a, _b;
            if (err != null && !((_a = data === null || data === void 0 ? void 0 : data.results) === null || _a === void 0 ? void 0 : _a.length)) {
                LOG.error("Failed to initialize Apple Map Geocoder lookup service for Event location - " + eventLocation);
            }
            if (((_b = data === null || data === void 0 ? void 0 : data.results) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                eventLatitude = data.results[0].coordinate.latitude;
                eventLongitude = data.results[0].coordinate.longitude;
                eventLatitudeSpan = data.results[0].region.span.latitudeDelta;
                eventLongitudeSpan = data.results[0].region.span.latitudeDelta;
            }
            _this.map = new window.mapkit.Map(_this.mapContainer, {
                region: new window.mapkit.CoordinateRegion(new window.mapkit.Coordinate(eventLatitude, eventLongitude), new window.mapkit.CoordinateSpan(eventLatitudeSpan, eventLongitudeSpan)),
                mapType: 'standard',
                showsZoomControl: false,
                showsScale: false,
                showsCompass: false,
                showsMapTypeControl: false,
                showsUserLocationControl: false
            });
            // annotations
            _this.setMapAnnotation(_this, eventLatitude, eventLongitude);
        });
    };
    AppleMapKit.prototype.setMapAnnotation = function (self, eventLatitude, eventLongitude) {
        // Landmark annotation
        var landmarks = [{ coordinate: new window.mapkit.Coordinate(eventLatitude, eventLongitude) }];
        // Landmarks annotations
        var annotations = landmarks.map(function (landmark) {
            var annotation = new window.mapkit.MarkerAnnotation(landmark.coordinate, {
                color: '#c969e0'
            });
            annotation.landmark = landmark;
            return annotation;
        });
        this.map.showItems(annotations);
    };
    AppleMapKit.prototype.componentWillUnmount = function () {
        this.map.destroy();
    };
    AppleMapKit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { ref: function (ref) { return (_this.mapContainer = ref); }, style: this.props.style });
    };
    AppleMapKit.defaultProps = {
        style: {
            width: '100%',
            height: '400px'
        }
    };
    return AppleMapKit;
}(Component));
export { AppleMapKit };
